import ApiFetcher from "../utils/ApiFetcher";
import { put, call } from "redux-saga/effects";
import { sagaListSuccess } from "../actions/ActionTypes";

export function* fetchMemberLookups(action) {
  const apiFetcher = new ApiFetcher();
  try {
    const res = yield call(apiFetcher.findAll, "lookup");
    yield put({
      type: sagaListSuccess("MEMBER_LOOKUPS"),
      data: res.data
    });
  } catch (e) {}
}



// WEBPACK FOOTER //
// ./src/sagas/member_lookups.js